import { useEffect, useState } from 'react';
import { SaleCartManager } from './SaleCartManager';

/**
 * React hook that returns the current free-delivery threshold (€).
 * Fetched once from the `general-settings` content-type and cached for the
 * session. Renders with a sensible default until the value arrives.
 */
export const useDeliveryThreshold = () => {
  const [threshold, setThreshold] = useState(SaleCartManager.getDeliveryThreshold());

  useEffect(() => {
    let cancelled = false;
    SaleCartManager.getDeliveryThresholdAsync().then((value) => {
      if (!cancelled) setThreshold(value);
    });
    return () => { cancelled = true; };
  }, []);

  return threshold;
};
